<template>
  <div class="tag-edit">
    <el-tag v-bind="$attrs">
      <slot></slot>
    </el-tag>
    <p v-if="msg" class="el-tag--danger">{{ msg }}</p>
    <!-- <el-button
      v-if="showEdit"
      type="text"
      icon="el-icon-refresh"
      size="mini"
      @click="onEdit"
      >退款</el-button
    > -->
  </div>
</template>

<script>
export default {
  name: "TagEdit",
  props: ["showEdit", "onEdit", "msg"],
};
</script>

<style lang="scss" scoped>
.tag-edit {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    font-size: 12px;
    margin: 5px 0;
    line-height: 1.5;
    color: #ff4949;
  }
}
</style>
